<template>
  <div :class="classes" class="buy-sell-trade-block">
    <div ref="container" class="buy-sell-trade-block__container">
      <trade-top-heading-block
        class="buy-sell-trade-block__trade-margins"
      >
        <trade-tabs-widget
          v-model="type"
          class="buy-sell-trade-block__tabs"
          :buttons="typeButtons"
        />

        <exc-checkbox
          id="reCheck"
          v-model="shouldOpenConfirmation"
          :label="$t('trade.reCheck')"
          class="buy-sell-trade-block__confirm-checkbox mobile"
          @input="recheckModalToggle"
        />

        <template v-if="isPairMarginTradeable">
          <div
            class="buy-sell-trade-block__margin-buttons flx"
          >
            <!--          <exc-button-->
            <!--            :outline="currentTradeType !== MARGIN_TRADE_SPOT"-->
            <!--            :color="currentTradeType === MARGIN_TRADE_SPOT ? 'main' : 'grey'"-->
            <!--            :disabled="!isPairMarginTradeable"-->
            <!--            size="xxs"-->
            <!--            class="buy-sell-trade-block__margin-button txt&#45;&#45;on-one-line"-->
            <!--            @click="$store.commit('trade/setMarginType', MARGIN_TRADE_SPOT)"-->
            <!--          >-->
            <!--            {{ $t('trade.buySell.spot') }}-->
            <!--          </exc-button>-->

            <!--          <exc-button-->
            <!--            v-if="isPairMarginTradeable"-->
            <!--            :outline="currentTradeType !== MARGIN_TRADE_CROSS"-->
            <!--            :color="currentTradeType === MARGIN_TRADE_CROSS ? 'main' : 'grey'"-->
            <!--            size="xxs"-->
            <!--            class="buy-sell-trade-block__margin-button txt&#45;&#45;on-one-line ml-10"-->
            <!--            @click="onClickCrossTrade"-->
            <!--          >-->
            <!--            <span class="buy-sell-trade-block__short-name">x3</span>-->
            <!--            <span class="buy-sell-trade-block__long-name txt&#45;&#45;height-10px">{{ `${$t('trade.buySell.margin')} x3` }}</span>-->
            <!--          </exc-button>-->

            <trade-tabs-switcher
              v-model="marginOrSpot"
              :buttons="btnsMarginOrSpot"
              class="buy-sell-trade-block__switch"
              @input="toggleTradingStyle"
            />
          </div>

          <div class="buy-sell-trade-block__empty-block" />

          <transition name="fade" mode="out-in" duration="500">
            <div
              v-if="currentTradeType === MARGIN_TRADE_CROSS"
              class="buy-sell-trade-block__margin-props mt-8 mt-0--m"
            >
              <calculator-component
                class="buy-sell-trade-block__round-btn"
                @click="showCalculatorModal = true"
              />

              <div
                v-if="loggedIn"
                class="buy-sell-trade-block__round-btn"
                @click="showTransferModal = true"
              >
                <span class="txt--12px txt--height-16px txt--bold txt--color-04">
                  {{ $t('trade.buySell.transfer') }}
                </span>
              </div>

              <div
                v-if="loggedIn"
                class="buy-sell-trade-block__round-btn"
                @click="showMarginModal = true"
              >
                <span class="txt--12px txt--height-16px txt--bold txt--color-04">
                  {{ $t('trade.buySell.borrow') }}
                </span>
              </div>
            </div>
          </transition>
        </template>
      </trade-top-heading-block>

      <trade-top-heading-block
        class="
          buy-sell-trade-block__tabs-block
          buy-sell-trade-block__block-with-tabs
          bor--bottom
          bor--transp-02
        "
      >
        <div class="buy-sell-trade-block__tabs-desktop">
          <!-- :disabled-tab-indexes="currentTradeType === MARGIN_TRADE_CROSS ? [0] : []" -->
          <exc-tabs
            :selected-button="marketOrLimit.value"
            :buttons="btns"
            tab-key="value"
            size="s"
            class="buy-sell-trade-block__tabs-block"
            @change-tab="
              (btn) => {
                marketOrLimit = btn
              }
            "
          />
        </div>
        <div class="buy-sell-trade-block__checkbox-container">
          <exc-checkbox
            id="reCheck"
            v-model="shouldOpenConfirmation"
            :label="$t('trade.reCheck')"
            class="buy-sell-trade-block__confirm-checkbox desktop"
            @input="recheckModalToggle"
          />
          <!-- <div
            :class="[shouldOpenConfirmation ? 'txt--main' : 'txt--grey']"
            class="
              buy-sell-trade-block__confirm-checkbox-mobile
              bor--left bor--transp-01
            "
            @click="recheckModalToggle"
          >
            <recheck-icon />
          </div> -->
        </div>
      </trade-top-heading-block>
      <!-- <trade-buy-sell-type-switcher
        v-model="type"
        class="buy-sell-trade-block__trade-switcher"
      /> -->

      <!-- LIMIT -->
      <template v-if="marketOrLimit.value === 'limit'">
        <buy-sell-control
          :key="`limit-buy-${currentPair}`"
          :size="size"
          trade-type="buy"
          class="buy-sell-trade-block__buy"
        />

        <buy-sell-control
          :key="`limit-cell-${currentPair}`"
          :size="size"
          trade-type="sell"
          class="buy-sell-trade-block__sell"
        />
      </template>

      <!-- MARKET -->
      <template v-if="marketOrLimit.value === 'market'">
        <buy-sell-control-market
          :key="`market-buy-${currentPair}`"
          :size="size"
          class="buy-sell-trade-block__buy"
          trade-type="buy"
        />
        <buy-sell-control-market
          :key="`market-cell-${currentPair}`"
          :size="size"
          class="buy-sell-trade-block__sell"
          trade-type="sell"
        />
      </template>

      <!-- STOP LIMIT -->
      <template v-if="marketOrLimit.value === 'stopLimit'">
        <buy-sell-control-stop-limit
          :key="`stop-limit-buy-${currentPair}`"
          :size="size"
          class="buy-sell-trade-block__buy"
          trade-type="buy"
        />
        <buy-sell-control-stop-limit
          :key="`stop-limit-sell-${currentPair}`"
          :size="size"
          class="buy-sell-trade-block__sell"
          trade-type="sell"
        />
      </template>

      <!-- OCO -->
      <template v-if="marketOrLimit.value === 'oco'">
        <buy-sell-control-oco
          :key="`oco-sell-${currentPair}`"
          :size="size"
          class="buy-sell-trade-block__buy"
          trade-type="buy"
        />
        <buy-sell-control-oco
          :size="size"
          class="buy-sell-trade-block__sell"
          trade-type="sell"
        />
      </template>

      <!-- MODALS -->
      <!-- modal with 'borrow' 'repay' tabs -->
      <trade-margin-modal
        v-if="showMarginModal"
        :current-ticker="getCurrentPair.stockTicker"
        @close="showMarginModal = false"
      />

      <wallet-balance-transfer-modal
        v-if="showTransferModal && selectedTransferBalance"
        :balance="selectedTransferBalance"
        margin-or-spot="margin"
        @close="showTransferModal = false"
      />

      <trade-modal-info
        v-if="showAccountModal"
        :text="modalText"
        @close="showAccountModal = false"
      />

      <trade-margin-calculator-modal
        v-if="showCalculatorModal"
        @close="showCalculatorModal = false"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { ExcTabs, ExcCheckbox } from '@/components/common'
import * as lockr from 'lockr'
// import { $t } from '@/lib/i18n'
import { MARGIN_TRADE_CROSS, MARGIN_TRADE_SPOT, TRADE_TYPE } from '@/lib/constants'
import { getDefaultWalletMarginBalanceModel } from '@/lib/data-models/wallet/WalletBalanceModel.ts'
import { LabeledValue } from '@/data-objects/props/LabeledValue'
// import i18n from '../../lib/localization';

// TODO: move to component to make reactive lang switch
// const MARKET_OR_LIMIT = [
//   new LabeledValue($t('trade.buySellControl.limit'), 'limit'),
//   new LabeledValue($t('trade.buySellControl.market'), 'market'),
//   new LabeledValue($t('trade.buySellControl.stopLimit'), 'stopLimit'),
//   new LabeledValue('OCO', 'oco'),
// ]

// function confirmationLocalStorageKey(tradeType) {
//     return `${tradeType}-confirmation-state`;
// }

// const defaultOrderType = MARKET_OR_LIMIT[0]

export default {
  name: 'BuySellTradeBlock',
  components: {
    TradeTopHeadingBlock: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeTopHeadingBlock.vue'),
    BuySellControl: () => import(/* webpackMode: "eager" */ '@/components/trade/trade-buy-sell-elements/BuySellControl'),
    BuySellControlMarket: () => import(/* webpackMode: "eager" */ '@/components/trade/trade-buy-sell-elements/BuySellControlMarket'),
    BuySellControlStopLimit: () => import(/* webpackMode: "eager" */ '@/components/trade/trade-buy-sell-elements/BuySellControlStopLimit'),
    BuySellControlOco: () => import('@/components/trade/trade-buy-sell-elements/BuySellControlOco'),
    TradeTabsSwitcher: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeTabsSwitcher.vue'),
    // BaseTabs: () => import(/* webpackMode: "eager" */ '@/components/base/BaseTabs.vue'),
    // FilterButtons: () =>
    //   import(
    //     /* webpackMode: "eager" */ '@/components/button/FilterButtons.vue'
    //   ),
    RecheckIcon: () => import(/* webpackMode: "eager" */ '@/assets/icons/trade/recheck.svg?inline'),
    ExcTabs,
    ExcCheckbox,
    // ExcButton,

    TradeMarginModal: () => import('@/components/modals/TradeMarginModal.vue'),
    // TradeTransferModal: () => import('@/components/modals/TradeTransferModal.vue'),
    TradeModalInfo: () => import('@/components/modals/TradeModalInfo.vue'),
    TradeMarginCalculatorModal: () => import('@/components/modals/TradeMarginCalculatorModal.vue'),
    WalletBalanceTransferModal: () => import('@/components/modals/WalletBalanceTransferModal.vue'),

    // ExcBaseTabs: () => import(/* webpackMode: "eager" */ '@/components/ui-kit/tabs/ExcBaseTabs.vue'),
    // TradeBuySellTypeSwitcher: () =>
    //   import(
    //     /* webpackMode: "eager" */ '@/components/trade/trade-buy-sell-elements/TradeBuySellTypeSwitcher.vue'
    //   ),
    CalculatorComponent: () => import(/* webpackMode: "eager" */ '@/assets/icons/calculator.svg?inline'),
    TradeTabsWidget: () => import(/* webpackMode: "eager" */ '@/components/trade/TradeTabsWidget.vue'),
  },
  props: {
    size: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      marketOrLimit: null,
      componentId: 'BuySellTradeBlock',
      type: null,
      confirmationState: false,
      showMarginModal: false,
      showTransferModal: false,
      showAccountModal: false,
      showCalculatorModal: false,
      modalText: this.$t('trade.buySellControl.modalText'),
      marginOrSpot: null,

      MARGIN_TRADE_CROSS,
      MARGIN_TRADE_SPOT,

      marginBalanceByPairTimeout: null,
      marginBalanceByPairTimeoutTime: 1000,
    }
  },
  computed: {
    ...mapState({
      currentTradeType: state => state.trade.currentTradeType,
      loggedIn: state => state.auth.loggedIn,
      currentPair: state => state.pairs.currentPair,
    }),
    ...mapGetters({
      marginBalances: 'wallet/getWalletMarginBalances',
      getCurrentPair: 'pairs/getCurrentPair',
      isPairMarginTradeable: 'pairs/isPairMarginTradeable',
    }),
    disableSwitcherMarginHover () {
      if (!process.client) return
      return this.$mq.resize && this.$mq.below(1024)
    },
    pairName () {
      return this.getCurrentPair.pairName
    },
    tradeTypeButtons () {
      return [MARGIN_TRADE_SPOT, MARGIN_TRADE_CROSS].map(id => ({
        id,
        text: this.$t(`trade.buySell.${id}`),
      }))
    },
    btnsMarginOrSpot () {
      return [
        new LabeledValue(this.$t('trade.buySell.spot'), 'spot'),
        new LabeledValue(this.$t('trade.buySell.margin'), 'margin'),
      ]
    },
    btns () {
      return [
        new LabeledValue(this.$t('trade.buySellControl.limit'), 'limit'),
        new LabeledValue(this.$t('trade.buySellControl.market'), 'market'),
        new LabeledValue(
          this.$t('trade.buySellControl.stopLimit'),
          'stopLimit',
        ),
        new LabeledValue('OCO', 'oco'),
      ]
    },

    typeButtons () {
      const { stockTicker: ticker } = this.getCurrentPair

      return Object.values(TRADE_TYPE)
        .map(btn => new LabeledValue(this.$t(`trade.typeButton.${btn}`, { ticker }), btn))
    },
    classes () {
      return {
        'buy-sell-trade-block--buy': this.type.value === TRADE_TYPE.BUY,
        'buy-sell-trade-block--sell': this.type.value === TRADE_TYPE.SELL,
      }
    },
    shouldOpenConfirmation: {
      get () {
        if (process.server) return true
        // return Boolean(this.confirmationState);
        if (lockr.get('trade-confirmation-state') !== undefined) {
          return !!this.confirmationState
        }
        lockr.set('trade-confirmation-state', true)
        return true
      },
      set (value) {
        if (process.server) return
        lockr.set('trade-confirmation-state', value)
      },
    },
    isMarginTrade () {
      return this.currentTradeType === MARGIN_TRADE_CROSS
    },
    selectedTransferBalance () {
      const balance = this.marginBalances.find(
        b => b.ticker === this.getCurrentPair.stockTicker,
      )
      return (
        balance ||
        getDefaultWalletMarginBalanceModel(this.getCurrentPair.stockTicker)
      )
    },
  },

  watch: {
    btnsMarginOrSpot: 'setCurrentItem',
    pairName () {
      if (!this.isPairMarginTradeable) {
        // console.log('MARGIN TRADABLE')
        this.$store.commit('trade/setMarginType', MARGIN_TRADE_SPOT)
        // this.toggleTab(this.btns[1])
      }
      if (this.isMarginTrade) {
        this.getMarginBalanceForMarginPair()
        this.$api.$unsubscribeMarginTradeAssets()
        this.$api.$subscribeMarginTradeAssets({ tickers: this.pairName.split('_') })
      }
      // if (this.loggedIn) {
      //     this.getMarginBalanceForMarginPair()
      // }
      // if (this.isMarginTrade) {
      // }
    },
    isMarginTrade (newVal) {
      if (newVal) {
        return this.$api.$subscribeMarginTradeAssets({
          tickers: this.pairName.split('_'),
        })
      }
      this.$api.$unsubscribeMarginTradeAssets()
    },
    currentTradeType (newVal) {
      const isExtendHeight = newVal !== MARGIN_TRADE_SPOT
      /**
       * Wait end of close animation (for close only)
       * We cannot use 0ms as a delay for open (animation is not working properly)
       */
      const _emit = () =>
        this.$emit('buy-sell-trade-extend-height', isExtendHeight)
      isExtendHeight ? _emit() : (process.client ? setTimeout(_emit, 550) : _emit())
    },
    marketOrLimit (newVal) {
      this.$emit('market-or-limit-value', newVal.value)
    },
  },

  beforeMount () {
    if (this.loggedIn) {
      // this.getMarginBalanceForMarginPair()
      // instead of sockets
      // this.marginBalanceByPairTimeout = window.setInterval(() => {
      //     // this.getMarginBalanceForMarginPair()
      // }, this.marginBalanceByPairTimeoutTime)
    }
  },

  beforeDestroy () {
    window.clearInterval(this.marginBalanceByPairTimeout)
    // reset to default
    this.$store.commit('trade/setMarginType', MARGIN_TRADE_SPOT)
  },

  created () {
    if (!this.marketOrLimit) this.marketOrLimit = this.btns[0]
    if (!this.type) this.type = this.typeButtons[0]

    if (process.client) {
      this.confirmationState = lockr.get('trade-confirmation-state', true)
      // this.marginBalanceByPairTimeoutTime = location.hostname === 'ibox.exchange' ? 10000 : 1000
    }

    this.setCurrentItem()
  },
  methods: {
    ...mapActions({
      getMarginBalance: 'wallet/getMarginBalance',
      getWalletMarginBalances: 'wallet/getWalletMarginBalances',
    }),
    async getMarginBalanceForMarginPair () {
      // if (this.isMarginTrade) {
      if (this.loggedIn) {
        await this.getMarginBalance(this.pairName.split('_'))
      }
      // }
    },
    setCurrentItem () {
      this.marginOrSpot = this.btnsMarginOrSpot[0]
    },
    toggleTradingStyle (v) {
      if (v.value === '') {
        return null
      }

      if (v.value.toLowerCase() === 'spot') {
        return this.$store.commit('trade/setMarginType', MARGIN_TRADE_SPOT)
      }

      this.onClickCrossTrade()
    },
    onClickCrossTrade () {
      this.$store.commit('trade/setMarginType', MARGIN_TRADE_CROSS)
      this.getMarginBalanceForMarginPair()
      // this.toggleTab(this.btns[1])
      // const resp = await api.$getMarginTradeBalances(this.pairName.split('_'))
      this.$api.$subscribeMarginTradeAssets({ tickers: this.pairName.split('_') })
      // console.log(resp)
      // this.toggleTab(this.btns[1])
    },
    changeCurrentTradeType (type) {
      this.$store.commit('trade/setMarginType', type.id)

      if (type.id === MARGIN_TRADE_CROSS) {
        this.getMarginBalanceForMarginPair()
        this.$api.$subscribeMarginTradeAssets({ tickers: this.pairName.split('_') })
      }
    },
    recheckModalToggle () {
      // console.log(this.shouldOpenConfirmation)
      this.confirmationState = !this.confirmationState

      lockr.set('trade-confirmation-state', this.confirmationState)
    },
    toggleTab (btn) {
      this.marketOrLimit = btn
    },
  },
}
</script>

<style lang="scss" scoped>
.buy-sell-trade-block {
  $root: &;
  height: auto;

  &__switch {
    &::v-deep {
      .exc-header-nav-item__dropdown {
        z-index: 1000;
      }

      .txt {
        padding-right: 46px;
      }
    }
  }

  &__tabs {
    @include bp(l) {
      display: none !important;
    }
  }

  &__round-btn {
    cursor: pointer;
  }

  &--buy {
    #{$root}__sell {
      display: none;

      @include bp(l) {
        display: block;
      }
    }
  }

  &--sell {
    #{$root}__buy {
      display: none;

      @include bp(l) {
        display: block;
      }
    }
  }

  &__container {
    height: 100%;

    // @include bp(0, m) {
    //   background: color(color-01);
    //   border-radius: 8px;
    // }

    @include bp(l) {
      display: grid;
      grid-template-rows: auto auto 1fr;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        'trade-margins trade-margins'
        'tabs-block tabs-block'
        'buy sell';
    }
  }

  &__trade-margins {
    grid-area: trade-margins;

    display: grid;
    align-items: center;
    grid-template-columns: auto auto;
    grid-template-rows: auto;
    justify-content: space-between;
    gap: space(10);
    padding: toRem(8px);

    @include bp(l) {
      padding: toRem(0);
      grid-template-rows: auto;
      grid-template-columns: 3fr 4fr;
    }
  }

  &__margin-buttons {
    margin-left: auto;

    @include bp(l) {
      margin-left: 0;
    }
  }

  &__margin-button {
    padding: toRem(6) toRem(16px);
  }

  &__margin-props {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: toRem(8px);
  }

  &__tabs-block {
    grid-area: tabs-block;
    display: flex;
    justify-content: space-between;
  }

  &__trade-switcher {
    @include bp(l) {
      display: none !important;
    }
  }

  &__buy {
    grid-area: buy;
  }

  &__sell {
    grid-area: sell;
  }

  &__checkbox-container {
    align-self: center;

    ::v-deep {
      .exc-checkbox__label {
        @include bp(375px, 550px) {
          font-size: toRem(10px);
        }
      }
    }

  }

  &__confirm-checkbox-mobile {
    display: none;
  }

  &__confirm-checkbox {
    display: block;
    height: 100%;

    @include bp(0, m) {
      &.mobile {
        display: flex;
        align-items: center;
      }

      &.desktop {
        display: none;
      }
    }

    @include bp(m) {
      &.mobile {
        display: none;
      }

      &.desktop {
        display: block;
      }
    }
  }

  &__tabs-desktop {
    display: block;
    height: toRem(38px);
  }

  &__tabs-block {
    height: toRem(38px);

    @include bp(m) {
      padding-bottom: 1px; // to place active tab underline on border bottom
    }

    ::v-deep {
      .exc-tabs__tab {
        padding-left: 0;
        padding-right: 0;
        margin-right: toRem(12px);
      }
    }
  }

  &__block-with-tabs {
    padding-left: toRem(12px);
    padding-right: toRem(12px);
  }

  &__short-name {
    @include bp(l) {
      display: none;
    }
  }

  &__long-name {
    @include bp(0, l) {
      display: none;
    }
  }

  &__empty-block {
    @include bp(l) {
      display: none;
    }
  }
}
</style>
